import type { components } from '@/shared/api/schema'

export const creditReadPermissions = ['finance.view_payable', 'procurement.view_purchase_amount', 'masterdata.view_supplier_finance']
export const creditBase = '/api/v1/finance/supplier-credits'
export type Credit = components['schemas']['SupplierCreditSummary']
export type CreditPage = components['schemas']['CreditPage']
export type CreditHistory = components['schemas']['CreditHistoryPage']
export const creditTargetLabels: Record<string, [string, string]> = {
  confirmed_invoice_match: ['已确认发票份额', 'Confirmed invoice portion'],
  unmatched_receipt_line: ['未匹配实收货款', 'Unmatched received goods'],
  service_fee_line: ['已确认服务费用', 'Confirmed service fee'],
}
const id = (value: unknown) => typeof value === 'number' && Number.isSafeInteger(value) && value > 0
const money = (value: unknown) => typeof value === 'string' && /^\d{1,14}\.\d{4}$/.test(value)
export function validateCredit(value: Credit, supplier: number): Credit {
  if (!value || !id(value.id) || value.supplier_id !== supplier || !id(value.version)
    || typeof value.doc_no !== 'string' || typeof value.source_no !== 'string' || !id(value.original_payable_id)
    || !money(value.issued_amount) || !['supplier_return', 'settlement_adjustment', 'freight_adjustment'].includes(value.source_kind)
    || typeof value.execution_available !== 'boolean' || typeof value.can_apply !== 'boolean'
    || ![null, 'application_refund_ledger_unavailable'].includes(value.execution_blocker)
    || value.execution_available && (!money(value.available_amount) || !money(value.applied_amount) || value.execution_blocker !== null)
    || !value.execution_available && (value.available_amount !== null || value.applied_amount !== null || value.can_apply)) throw new Error('credit contract')
  return value
}
export function validateCreditHistory(value: CreditHistory, supplier: number, creditId: number): CreditHistory {
  validateCredit(value?.credit, supplier)
  if (value.credit.id !== creditId || value.scope_basis !== 'currently_authorized_sources'
    || !Number.isSafeInteger(value.count) || value.count < 0 || !Array.isArray(value.results)
    || value.results.some(row => !id(row.id) || !id(row.target_id) || !id(row.payable_id) || !id(row.sequence)
      || !money(row.amount) || !Object.hasOwn(creditTargetLabels, row.target_kind)
      || typeof row.payable_no !== 'string' || typeof row.reason !== 'string' || typeof row.applied_at !== 'string')) throw new Error('history contract')
  return value
}
